export default __webpack_public_path__ + "static/media/maestro-old.7c99df33.svg";